namespace Matrix.Data {

	@Serenity.Decorators.registerClass()
	export class SecurityMatchRulePickerDialog extends Serenity.TemplatedDialog<any> {

		private pickerGrid: SecurityMatchRulePickerGrid;

		constructor() {
			super();

			this.pickerGrid = new SecurityMatchRulePickerGrid(this.byId("PickerGrid"));
			this.dialogTitle = "Select Rules";
		}

		protected getTemplate() {
			return `<div id="~_PickerGrid"></div>`;
		}

		protected getDialogOptions() {
			var opt = super.getDialogOptions();
			opt.buttons = [
				{
					text: Q.text("Dialogs.OkButton"),
					click: () => {
						var selected = this.pickerGrid.selectedItems;
						if (!selected.length) {
							Q.notifyWarning("Please select some Rules!");
							return;
						}

						if (!this.onSuccess || this.onSuccess(selected))
							this.dialogClose();
					}
				},
				{
					text: Q.text("Dialogs.CancelButton"),
					click: () => {
						this.dialogClose();
					}
				}
			];
			return opt;
		}

		get selectedItems() {
			return this.pickerGrid.selectedItems;
		}

		set criteria(value: any[]) {
			this.pickerGrid.criteria = value;
		}

		public onSuccess: (selected: SecurityMatchRuleRow[]) => boolean;
	}
}